export default __webpack_public_path__ + "static/media/Luxor.1f939bf1.png";